module.exports = __webpack_public_path__ + "fonts/CeraPro-Light.c906b10.eot";